export default {
  scale: 5,

  rating: 2,

  variation: 'star',
  
  emptyColor: 'var(--color-greyDefault)',

  filledColor: '#ffd500',

  spacing: {
    desktop: 4,
  },

  size: {
    desktop: 20,
  }
}
